import React from 'react';

import { useSelector } from 'react-redux';
import { Redirect } from 'react-router-dom';

import { withSentry } from '../../../shared/hoc/withSentry';
import { ACL, UserCan } from '../../../shared/constants';
import { iFullStoreState } from '../../../shared/interfaces';

import DashboardBlock from '../../DashboardBlock';
import ModalHeader from '../../menus/modal/modal-header';
import DevicePeopleToggle from './device-people-toggle';

const Dashboard = () => {
    localStorage.removeItem("doNotShowAdModalAgain");

  const userCanDo = useSelector<iFullStoreState, Array<string>>((s) => s.auth.user?.acl?.can);
  const hideDashboard = ACL.check(UserCan.HIDE_DASHBOARD_PAGE, userCanDo, true);

  // https://mastrack.atlassian.net/browse/MAS-1359
  if (hideDashboard) return <Redirect to='/device' />

    return (
        <DashboardBlock>
            <ModalHeader title="Recent" />
            <DevicePeopleToggle />
        </DashboardBlock>
    )
};


export default withSentry(Dashboard);
